import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=1122ad75"
import script from "./SetupWizard.vue?vue&type=script&lang=ts"
export * from "./SetupWizard.vue?vue&type=script&lang=ts"
import style0 from "./SetupWizard.vue?vue&type=style&index=0&id=1122ad75&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1122ad75')) {
      api.createRecord('1122ad75', component.options)
    } else {
      api.reload('1122ad75', component.options)
    }
    module.hot.accept("./SetupWizard.vue?vue&type=template&id=1122ad75", function () {
      api.rerender('1122ad75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/SetupWizard.vue"
export default component.exports